//
// Reel manager class
//
// Used to create and manage reels
// New functionality for cascade reel

reelManager.createCascadeReel = function(json)
{
    var reel = cascadeReelTemplate.createReel(-1, json, gameController.onSymbolLandedCallback );
    reelManager.reels.push(reel);
    return reel;

};

resourceManager.registerObjectType("cascadeReel", reelManager.createCascadeReel, reelManager.initialiseReel, reelManager.getReelFiles, reelManager.destroyReel);
